@if (store.canRead() && stack().length) {
  <button type="button" class="activity-stack" aria-describedby="members-activity-panel"
    [attr.aria-label]="'menu.activity.label' | translate">
    @for (member of stack(); track member.account.accountId; let front = $last) {
      <span class="avatar" [class.idle]="!member.active">
        <app-display-user-logo [user]="member.account" [size]="32"></app-display-user-logo>
        <!-- Only the front avatar shows its dot (the next avatar would not hide the others' entirely), and only
             while no "+X" covers it. -->
        @if (front && !stackHiddenCount()) {
          <span class="status-dot" [class.active]="member.active"></span>
        }
      </span>
    }
    <!-- The colleagues left out: a "+X" disc at the front, on the right. -->
    @if (stackHiddenCount()) {
      <span class="avatar more-disc">+{{ stackHiddenCount() }}</span>
    }
  </button>

  <div id="members-activity-panel" class="activity-panel" role="tooltip">
    <div class="activity-list">
      @for (member of panelMembers(); track member.account.accountId) {
        <div class="member">
          <span class="avatar">
            <app-display-user-logo [user]="member.account" [size]="32"></app-display-user-logo>
            <span class="status-dot" [class.active]="member.active"></span>
          </span>
          <span class="member-texts">
            <span class="member-name">{{ member.name }}</span>
            <span class="member-status" [class.active]="member.active">{{ member.statusKey | translate: {value: member.statusValue} }}</span>
          </span>
        </div>
      }
      @if (panelHiddenCount()) {
        <div class="member more">
          <span class="more-disc">+{{ panelHiddenCount() }}</span>
          <span class="member-texts member-name">{{ hiddenLabelKey() | translate }}</span>
        </div>
      }
    </div>
  </div>
}
